import { z } from 'zod';

/**
 * Complete warranty registration form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(completeWarrantyRegistrationFormSchema)
 */
const completeWarrantyRegistrationFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm warranty registration is complete',
    }),
});

export { completeWarrantyRegistrationFormSchema };
//# sourceMappingURL=warrantyValidation.js.map
